import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 9,
	viewBox: "0 0 6 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.750625 0.532822C0.458125 0.825322 0.458125 1.29782 0.750625 1.59032L3.66063 4.50032L0.750625 7.41032C0.458125 7.70282 0.458125 8.17532 0.750625 8.46782C1.04313 8.76032 1.51562 8.76032 1.80813 8.46782L5.25063 5.02532C5.54313 4.73282 5.54313 4.26032 5.25063 3.96782L1.80813 0.525322C1.52312 0.240322 1.04313 0.240322 0.750625 0.532822Z",
		fill: "#1D1D1D"
	})
});
export default SvgArrowLeft;
